import ProductBrandDetailPanel from './productBrandDetailPanel.container';

export default ProductBrandDetailPanel;